import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  role: "list",
  class: "pt-2 mb-10 overflow-hidden bg-white divide-y divide-clay-300 sm:rounded-xl"
}
const _hoisted_4 = { class: "items-center justify-between min-w-full sm:flex" }
const _hoisted_5 = { class: "flex gap-6 py-4 sm:pt-6 sm:py-6" }
const _hoisted_6 = { class: "w-32 shrink-0" }
const _hoisted_7 = ["href", "title"]
const _hoisted_8 = ["src", "alt", "title"]
const _hoisted_9 = { class: "space-y-1.5" }
const _hoisted_10 = { class: "font-semibold text-clay-950" }
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = { class: "text-xs/6 text-clay-800" }
const _hoisted_13 = { class: "flex mt-1 text-xs leading-5 text-clay-800" }
const _hoisted_14 = { class: "flex items-center gap-x-1.5" }
const _hoisted_15 = { class: "flex items-center gap-x-1.5" }
const _hoisted_16 = { class: "text-xs leading-5 text-clay-800" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex items-center shrink-0 gap-x-4" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center shrink-0 gap-x-4"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "inline-flex items-center gap-x-1 text-electric-100" }
const _hoisted_23 = ["href", "title"]
const _hoisted_24 = { key: 1 }

import { computed, onMounted, ref } from "vue";
import { client } from "@/shared";
import {
  GetOpportunitiesPostedByMe,
  GetOpportunitiesPostedByMeResponse
} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
// @ts-ignore
import Paginate from "vuejs-paginate-next";
import { store } from "@/store";
import SaSocialShare from "@/main/components/SaSocialShare.vue";
import { ShareIcon, ChevronRightIcon, ShoppingCartIcon, ClockIcon } from '@heroicons/vue/24/solid';

const nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

const prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;

export default /*@__PURE__*/_defineComponent({
  __name: 'MyOpportunities',
  setup(__props) {

const responseStatus = ref({});

const request = ref(new GetOpportunitiesPostedByMe({}));
const opportunitiesPostedByMeResponse = ref(
  new GetOpportunitiesPostedByMeResponse()
);

const opportunities = computed(() => {
  return opportunitiesPostedByMeResponse.value.results;
});

onMounted(async () => {
  await getMyOpportunities();
});

const resultsSection: any = ref(null);
const shouldScroll = ref(false);
const opportunitiesRetrieved = ref(false);

const getMyOpportunities = async () => {
  opportunitiesRetrieved.value = false;
  await client
    .get<GetOpportunitiesPostedByMeResponse>(request.value)
    .then(response => {
      opportunitiesRetrieved.value = true;
      opportunitiesPostedByMeResponse.value = response;
      if (shouldScroll.value) {
        resultsSection.value.scrollIntoView({
          behavior: "smooth"
        });
      }
      shouldScroll.value = true;
    });
};

const generateOpportunityUrl = (opportunity: any) => {
  return `${window.location.origin}/${opportunity.id}/${opportunity.slug}`;
};

const clickHandler = async (pageNum: any) => {
  request.value.currentPage = pageNum;
  await getMyOpportunities();
};

const getPageCount = () => {
  return Math.ceil(opportunitiesPostedByMeResponse.value.totalResults / 12);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
    _createElementVNode("div", {
      ref_key: "resultsSection",
      ref: resultsSection,
      class: "min-h-screen"
    }, [
      (opportunitiesRetrieved.value === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (opportunitiesPostedByMeResponse.value.results?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"pb-4 mt-10\"><div class=\"md:flex md:items-center md:justify-between\"><div class=\"flex-1 min-w-0\"><h3 class=\"text-xl font-bold leading-6 text-gray-900\"> Opportunities </h3></div><div class=\"flex mt-4 md:ml-4 md:mt-0\"><p class=\"text-sm text-clay-800\"><a href=\"/opportunities/post\" class=\"underline\">Click here</a> to post a new opportunity </p></div></div></div>", 1)),
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunities.value, (opportunity) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: opportunity.id,
                        class: "relative flex justify-between px-4 gap-x-6 hover:bg-clay-50 dark:hover:bg-gray-800 sm:px-6"
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("a", {
                                "aria-hidden": "true",
                                href: `/my-posts/${opportunity.id}/edit`,
                                title: opportunity.title
                              }, [
                                _createElementVNode("img", {
                                  class: "object-cover rounded-lg shadow-sm aspect-3/2",
                                  src: opportunity.imageUrl,
                                  alt: opportunity.title,
                                  title: opportunity.title
                                }, null, 8, _hoisted_8)
                              ], 8, _hoisted_7)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("a", {
                                  href: `/my-posts/${opportunity.id}/edit`,
                                  title: opportunity.title
                                }, _toDisplayString(opportunity.title), 9, _hoisted_11)
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex-none p-1 rounded-full", 
                              opportunity.isVisible
                                ? 'bg-emerald-500/20'
                                : 'bg-orange-500/20'
                            ])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["h-1.5 w-1.5 rounded-full", 
                                opportunity.isVisible
                                  ? 'bg-emerald-500'
                                  : 'bg-orange-500'
                              ])
                                        }, null, 2)
                                      ], 2),
                                      _createElementVNode("p", _hoisted_16, _toDisplayString(opportunity.isVisible ? "Visible" : "Hidden"), 1)
                                    ])
                                  ])
                                ]),
                                (opportunity.isVisible)
                                  ? (_openBlock(), _createBlock(SaSocialShare, {
                                      key: 0,
                                      title: opportunity.title,
                                      url: generateOpportunityUrl(opportunity)
                                    }, {
                                      trigger: _withCtx(({ openShareModal }) => [
                                        _createElementVNode("a", {
                                          onClick: _withModifiers(openShareModal, ["prevent"]),
                                          class: "flex items-center gap-x-1.5 text-xs leading-5 text-clay-800 mt-1"
                                        }, [
                                          _createVNode(_unref(ShareIcon), {
                                            class: "w-3.5 h-3.5 sm:w-4 sm:h-4 text-current",
                                            alt: "share icon",
                                            title: "share icon"
                                          }),
                                          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Share", -1))
                                        ], 8, _hoisted_17)
                                      ]),
                                      _: 2
                                    }, 1032, ["title", "url"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            (_unref(store).saUserSession.subscriptionType !== 'pro')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  (opportunity.unlockedUntilInPstAsString != 'N/A')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: `/my-posts/${opportunity.id}/edit`,
                                        title: "Edit",
                                        class: "hidden p-1 mt-1 text-xs font-semibold text-gray-600 rounded-md sm:flex"
                                      }, " Expires on " + _toDisplayString(opportunity.unlockedUntilInPstAsString), 9, _hoisted_20))
                                    : _createCommentVNode("", true),
                                  (opportunity.canBeUnlocked)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: `/${opportunity.id}/checkout`,
                                        class: "p-1 w-28 text-center text-sm font-semibold rounded-full shadow-sm bg-electric-600 text-electric-100 hover:bg-electric-700 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-electric-700"
                                      }, [
                                        _createElementVNode("span", _hoisted_22, [
                                          (opportunity.unlockedUntilInPstAsString != 'N/A')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createVNode(_unref(ClockIcon), {
                                                  class: "w-4 h-4",
                                                  title: "Extend"
                                                }),
                                                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Extend", -1))
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createVNode(_unref(ShoppingCartIcon), {
                                                  class: "w-4 h-4",
                                                  title: "Publish"
                                                }),
                                                _cache[3] || (_cache[3] = _createElementVNode("span", null, "Publish", -1))
                                              ], 64))
                                        ])
                                      ], 8, _hoisted_21))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("a", {
                              href: `/my-posts/${opportunity.id}/edit`,
                              title: opportunity.title,
                              class: "hidden sm:inline-block"
                            }, [
                              _createVNode(_unref(ChevronRightIcon), { class: "flex-none w-5 h-5 text-gray-400" })
                            ], 8, _hoisted_23)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_unref(Paginate), {
                    modelValue: opportunitiesPostedByMeResponse.value.currentPage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((opportunitiesPostedByMeResponse.value.currentPage) = $event)),
                    "active-class": 
            'border-electric-500 text-electric-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
          ,
                    "click-handler": clickHandler,
                    "container-class": 
            'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0 mt-8'
          ,
                    "margin-pages": 2,
                    "next-class": '-mt-px w-0 flex-1 flex justify-end',
                    "next-link-class": 
            'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-gray-300'
          ,
                    "next-text": nextHtml,
                    "page-class": 
            'border-transparent text-clay-800 hover:text-gray-700 hover:border-gray-300 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
          ,
                    "page-count": getPageCount(),
                    "page-range": 3,
                    "prev-class": '-mt-px w-0 flex-1 flex',
                    "prev-link-class": 
            'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-gray-300'
          ,
                    "prev-text": prevHtml
                  }, null, 8, ["modelValue", "page-count"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[5] || (_cache[5] = [
                  _createElementVNode("p", { class: "text-2xl font-semibold text-center" }, " You have not posted any opportunities. ", -1),
                  _createElementVNode("div", { class: "max-w-2xl pb-8 mx-auto lg:text-center" }, [
                    _createElementVNode("p", { class: "mt-8 mb-4 text-lg leading-8 text-gray-600" }, " Want to promote an audition, class or performance among the StageAgent community? "),
                    _createElementVNode("a", {
                      href: "/opportunities/post",
                      class: "items-center px-4 py-2 mt-4 text-sm font-medium text-gray-900 uppercase bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                    }, " Post an Opportunity ")
                  ], -1)
                ])))
          ]))
        : (_openBlock(), _createBlock(SkeletonCard, {
            key: 1,
            "num-of-cards": 2,
            "card-style": "non-card"
          }))
    ], 512)
  ], 64))
}
}

})